module.exports = __webpack_public_path__ + "static/circularstd-black-abecdec13db5a68850891a0bacce4ab0.woff2";